import { OnInit, Component, Input, Output, EventEmitter } from '@angular/core';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { DashboardService } from '../../services/dashboard.service';
import { LazyService } from '../../../../services/lazy.service';
import { FilterState } from '../dashboard-filters/dashboard-filters.component'; 

declare var supersetEmbeddedSdk: any;

@Component({
    selector: 'dashboard-superset',
    templateUrl: './superset.component.html',
    styleUrls: ['./superset.component.scss'],
    standalone: false
})
export class SupersetComponent implements OnInit {

  @Input() data: any;
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  
  config: any = { loaded: false, data: {} };
  currentFilters: FilterState;

  // Exact same settings structure as Power BI
  fySettings = {
    startMonth: 3, 
    isYearAhead: false 
  };

  constructor(
    private loader: LoaderService,
    public dashBoardService: DashboardService,
    private lazyService: LazyService
  ) {}

  ngOnInit() {
    // Dynamic config override (optional, keeps logic flexible)
    if (this.data && this.data.settings && this.data.settings.fy_start_month !== undefined) {
       this.fySettings.startMonth = parseInt(this.data.settings.fy_start_month);
    }

    if (typeof supersetEmbeddedSdk === 'undefined') {
      this.lazyService.loadScript("/assets/js/superset.min.js", true);
    }
  }

  handleFilterUpdate(filterState: FilterState) {
    this.currentFilters = filterState;
    this.build();
  }
 
  build() {
    this.config.loaded = false;
    this.loader.showSpinner();

    let configObject: any = {};
    if(this.currentFilters?.facilityId) {
        configObject.facility_id = this.currentFilters.facilityId;
    }

    this.dashBoardService.getWidgetData(this.data.widget_id, (data) => {
      if(data){
        this.config.data = data;
      configObject.url = btoa(this.config.data.link);
      
      this.dashBoardService.getDashboardUrl(this.config.data.query_id, 'superset', configObject, (url) => {
        if(!url){
            this.config.loaded = true;
        }
        // 1. GET RAW MILLISECOND PARAMS
        const jinjaParams = this.getEpochParams();

        const container = document.getElementById("my-superset-container");
        container.innerHTML = ""; 

        supersetEmbeddedSdk.embedDashboard({
          id: this.config.data.query_id,
          supersetDomain: this.config.data.link,
          mountPoint: container,
          fetchGuestToken: () => url,
          dashboardUiConfig: { 
              hideTitle: true,
              filters: { expanded: false, visible: true },
              // 2. PASS RAW NUMBERS TO SUPERSET URL
              urlParams: jinjaParams
          }
        }).then(() => {
           this.loader.hideSpinner();
           this.config.loaded = true;
        });

        setTimeout(() => {
            const frame = container.children[0] as any;
            if(frame) { frame.width = "100%"; frame.height = "100%"; }
        }, 500);
      });
      }else{
        this.loader.hideSpinner();
        this.config.loaded = true;
      }
      
    });
  }

  getEpochParams() {
    let params: any = {};

    if (this.currentFilters && this.currentFilters.fy) {
      // Calculate using the EXACT Power BI function
      const { startMs, endMs } = this.dashBoardService.getEpochRange(this.fySettings,this.currentFilters.fy, this.currentFilters.timezoneOffset || 0);
      
      // Pass the raw numbers (converted to string for URL safety, Superset/Jinja will handle them)
      params['start_epoch'] = startMs.toString();
      params['end_epoch']   = endMs.toString();
    }
    
    if(this.currentFilters?.facilityId){
        params['facility_id'] = this.currentFilters.facilityId;
    }

    return params;
  }

  
}